<template lang="pug">
  v-form
    v-row()
      v-col(cols="11")
        v-window(
          v-model="activeWindow"
          vertical
        )
          v-window-item(
            :key="entity.name"
          )
            v-card
              v-card-text
                slot(
                  :name="entity.name",
                  :entity="entity",
                  :selector="false",
                  :chips="false",
                  :relation="entity"
                  :value="instance",
                  :sections="sections.filter(x => x.section === entity.name || x.section === entity.tabLabel)",
                )
                  app-entity(
                    :entity="entity",
                    :selector="false",
                    :chips="false",
                    :relation="entity",
                    :parent="entity",
                    :extra-data="false",
                    v-bind="{ disabled }",
                  )
                  template(v-for="section in sections.filter(x => x.section === entity.name || x.section === entity.tabLabel)")
                    slot(:name="section.name", :path="section.name", :parent="entity", :parent-instance="instance", :relation="section", :entity="$findEntity(section.type)", v-bind="{ disabled }")
                      app-entity-relation(:path="section.name", :parent="entity", :parent-instance="instance", :relation="section", :entity="$findEntity(section.type)", v-bind="{ disabled }")
          v-window-item(
            v-for="(relation, tabIndex) in relations"
            :key="relation.name"
          )
            v-card
              v-card-text
                app-instance-history(v-if="relation.type === 'IEntityLog'", :instance="instance")
                slot(v-else, :name="relation.name", :path="relation.name", :parent="entity", :parent-instance="instance", :relation="relation", :entity="$findEntity(relation.type)" :isActive="active === relation.name")
                  app-entity-relation(:path="relation.name", :parent="entity", :parent-instance="instance", :relation="relation", :entity="getEntityRelation(relation)", :isActive="active === relation.name", v-bind="{ disabled }")
                  template(v-for="section in sections.filter(x => x.section === relation.name)")
                    slot(:name="section.name", :path="section.name", :parent="entity", :parent-instance="instance", :relation="section", :entity="$findEntity(section.type)", v-bind="{ disabled }")
                      app-entity-relation(:path="section.name", :parent="entity", :parent-instance="instance", :relation="section", :entity="$findEntity(section.type)", :isActive="active === section.section", v-bind="{ disabled }")
      v-col(cols="1")
        v-item-group(
          v-model="activeWindow"
          class="shrink"
          mandatory
        )
          v-item(
            v-for="(relation, tabIndex) in [{...entity, root: true}].concat(relations)"
            :key="relation.name"
            v-slot="{ active, toggle }"
          )
            div.d-flex.align-start(class="item")
              v-btn(
                class="item-button"
                :input-value="active"
                icon
                @click="changeStep(tabIndex)"
                :class="{ error: !disregardErrorInTab(tabIndex) && (errorInTab(relation) || formatedErrors(relation).length) }",
              )
              span(class="item-text") {{ getLabel(relation) }}
    v-row.pl-5(v-if="entity", align="center")
      v-col(cols="11").py-0
        g-btn.mr-3.white--text.float-right(v-if="lastStep || isEditing", :disabled="disableSubmit", color="geoGreen", @click="submit", ) {{ $t('Common.submit') }}
        g-btn.mr-3.white--text.float-right(v-if="!lastStep", color="primary", @click="next", ) {{ $t('Common.next') }}
        g-btn.mr-3.float-right(color="primary", outlined, @click="previous", ) {{ $t('Common.previous') }}
        g-btn.mr-3.float-right(color="error", outlined, @click="redirectToIndex", ) {{ $t('Common.cancel') }}
        g-btn.mr-3.white--text.float-left(v-if="hasDraftPermission", color="geoGreen", @click="saveAsDraft", ) {{ $t('Common.saveAsDraft') }}

</template>

<style lang="scss" scoped>
.item {
  padding-bottom: 10px;
  margin-bottom: 35px;
  width: 150px;
}

.item-button {
  width: 15px;
  height: 15px;
  text-align: center;
  line-height: 2em;
  border-radius: 1em;
  background: var(--v-primary-base);
  margin: 5px 0 0 5px;
  color: white;
  position: relative;
}

.item-text {
  font-size: 10px;
  padding: 5px 0 0 7px;
  margin-left: 18px;
  position: absolute;
}

.v-btn--icon.v-size--default {
  width: 15px;
  height: 15px;
}

.v-item--active > .item-button {
  background: var(--v-primary-base);
}

.v-item--active ~ .item > .item-button {
  background: var(--v-geoLightGray-base);
}

.v-item--active ~ .item > .item-button:not(.error)::after  {
  background: var(--v-geoLightGray-base);
}

.v-item--active > .item-button:not(.error)::after  {
  background: var(--v-geoLightGray-base);
}

.error::after {
  background: var(--v-geoMagenta-base) !important;
}

.item > .item-button::after {
  content: '';
  position: absolute;
  top: 14px;
  left: 6px;
  width: 3px;
  height: 63px;
  background: var(--v-primary-base);
}

.item:last-child > .item-button::after {
  display: none;
}

.v-window__container > .v-window-item > .v-card  {
  background: white;
  min-height: 83vh;
  max-height: 83vh;
  overflow-y: auto;
  overflow-x: hidden !important;

  &::-webkit-scrollbar{
    width: 5px;
    height: 300px;
  }
  &::-webkit-scrollbar-thumb{
    background: var(--v-geoLightGray-base);
    border-radius: 30px;
  }
}

</style>

<script>
import EntityMixin from '@/mixins'
export default {
  name: 'EntityStepper',
  mixins: [EntityMixin],
  props: {
    isEditing: {
      type: Boolean,
      default: false
    },
    hasDraftPermission: {
      type: Boolean,
      default: false
    },
    entity: {
      type: Object,
      default: () => ({})
    },
    customLabel: {
      type: Object,
      default: () => ({}),
    },
    tabsWithErrors: {
      type: Array,
      default: () => ([]),
    },
    disregardErrorInTabs: {
      type: Array,
      default: () => ([]),
    },
    disableErrorTabs: {
      type: Boolean,
      default: false,
    },
    tabsProps: {
      type: Object,
      default: () => ({}),
    },
    disableSubmit: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      activeWindow: 0
    }
  },
  methods: {
    redirectToIndex() {
      this.$emit('redirectToIndex');
    },
    submit(){
      this.$emit('submit');
    },
    saveAsDraft() {
      this.$emit('saveAsDraft');
    },
    changeStep(index){
      this.isEditing ? this.activeWindow = index : null;
    },
    errorInTab({ name }) {
      return this.tabsWithErrors.some(e => e == name);
    },
    disregardErrorInTab(tabindex) {
      return this.disregardErrorInTabs.some(e => e == tabindex);
    },
    formatedErrors(relation) {
      if (this.disableErrorTabs) return []
      return Object.keys(this.$formatErrors(this.$store.state.errors, relation))
    },
    findTabErrors(errors, relation) {
      return errors
    },
    getLabel(val) {
      var labelAttribute = val.tabLabel || val.name;
      if (!labelAttribute) return '';
      labelAttribute = labelAttribute.replace(/\_[\d]+/, '')
      let customLabelObject = this.customLabel;
      //If the customLabel prop is empty and the entity has customLabel property on the projectConfig, use them
      if(_.isEmpty(customLabelObject) && this.$getCustomLabel(this.entity.name)) {
        customLabelObject = this.$getCustomLabel(this.entity.name);
      }
      const customValue = _.get(customLabelObject, labelAttribute);
      return customValue ? this.$displayName(customValue) : this.$camelToString(this.$displayName(labelAttribute));
    },
    previous(){
      this.activeWindow == 0 ? this.activeWindow = 0 : this.activeWindow--;
    },
    next(){
      this.activeWindow == this.entityLength-1 ? this.activeWindow = this.entityLength-1 : this.activeWindow++;
    },
    getEntityRelation(relation) {
      const { type, extra } = relation;
      if (this.portal && extra) return relation;
      return this.$findEntity(type)
    },
  },
  created () {
    this.$store.commit('SET_INSTANCE', { extraData: [], ...this.instance, entityState: this.instance && this.instance.id ? 3 : 4, _Entity: this.entity.name })

    if(this.isEditing) {
      this.activeWindow = this.hasSummary ? this.entityLength - 1 : 0;
    }
    if (this.$route.query.fromComments) {
      this.activeWindow = this.relations.findIndex(x => x.type == "Comment") + 1;
    } else if (this.$route.hash) {
      // console.log('Relations hashes', _.map(this.relations, 'type'))
      const stepName = _.findIndex(this.relations, ['type', this.$route.hash.replace('#', '')]);
      if (stepName != -1) this.activeWindow = stepName + 1;
    }
  },
  computed: {
    sections () {
      return this.$fields(this.entity, null, [], [], [], true)
        .filter(p => !p.primitive && p.section)
        .filter(f => !this.ignoreTabs.find(iT => f.name === iT));
    },
    tabsFinalProps() {
      return _.assign({}, this.tabsDefaultProps, this.tabsProps);
    },
    entityWithRelations() {
      return [{...this.entity}].concat(this.relations);
    },
    entityLength() {
      return this.entityWithRelations.length;
    },
    lastStep() {
      return this.entityWithRelations[this.entityLength-1] == this.entityWithRelations[this.activeWindow];
    },
    active() {
      return this.entityWithRelations[this.activeWindow].name;
    },
    hasSummary() {
      return this.entityWithRelations.filter(e => e.name == 'summary').length > 0;
    }
  }
}
</script>
